<script setup lang="tsx">
import Multiselect from 'vue-multiselect'
import { computed, onBeforeUnmount, ref } from 'vue'
import { multiProps } from './props'
import ClearButton from './ClearButton.vue'
import { type Column } from '@/stores/column'

const isOpen = ref(false)
const model = defineModel<Column>({ required: true })
const props = defineProps({
	...multiProps,
	formatter: Function,
})
const internalModel = computed({
	get: () => {
		if (!model.value.filter.length) return []

		const opts = props.options?.filter((x: any) => model.value.filter.includes(props.valueField ? x[props.valueField] : x))

		if (props.formatter) {
			return opts.map((x: any) => {
				if (props.labelField) {
					x[props.labelField] = props.formatter!(props.valueField ? x[props.valueField] : x)
					return x
				}

				return props.formatter!(props.valueField ? x[props.valueField] : x)
			})
		}

		return opts
	},
	set: (newValue: any[]) => {
		model.value.filter = newValue.map((x) => (props.valueField ? x[props.valueField] : x))
	},
})
onBeforeUnmount(() => (model.value.filter = []))
</script>

<template>
	<Multiselect
		:multiple="true"
		:show-labels="false"
		:hide-selected="true"
		:close-on-select="false"
		:clear-on-select="false"
		:id="props.id"
		:searchable="props.searchable"
		:disabled="props.disabled"
		:placeholder="model.label + '...'"
		:options="props.options"
		v-model="internalModel"
		:label="props.labelField"
		:track-by="props.valueField"
		@open="isOpen = true"
		@close="isOpen = false"
		:limit="isOpen ? 100 : 3"
	>
		<template #clear>
			<ClearButton right="2rem" v-if="internalModel.length" @click="internalModel = []"></ClearButton>
		</template>

		<template v-if="!isOpen" #limit>
			<strong class="multiselect__strong">{{ $t('misc.limit', [internalModel.length - 3]) }}</strong>
		</template>
	</Multiselect>
</template>
